// Simple WebAuthn biometric helper (client-side only, no server verification).
// On supported devices (mobile fingerprint/Face ID, Mac Touch ID, Win Hello),
// this triggers the platform authenticator UI. Returns true on success.
export async function requestBiometric(userIdStr, nameStr) {
  if (typeof window === "undefined" || !window.PublicKeyCredential) return false;
  try {
    const available = await PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable?.();
    if (available === false) return false;
    const challenge = crypto.getRandomValues(new Uint8Array(32));
    const uid = new TextEncoder().encode(userIdStr || "user");
    const cred = await navigator.credentials.create({
      publicKey: {
        challenge,
        rp: { name: "Cantiere360", id: window.location.hostname },
        user: { id: uid, name: nameStr || "operaio", displayName: nameStr || "Operaio" },
        pubKeyCredParams: [{ type: "public-key", alg: -7 }, { type: "public-key", alg: -257 }],
        authenticatorSelection: { authenticatorAttachment: "platform", userVerification: "required" },
        timeout: 30000,
        attestation: "none",
      },
    });
    return !!cred;
  } catch (e) {
    return false;
  }
}
